import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'bursa-nivel-2',
  meta: {
    siteTitle: 'Caruta cu bani - curs de investitii eficiente pe bursa nivelul 2',
    ogSiteName: 'Caruta Cu Bani',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/',
    ogImage: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/assets/images/bursa-nivel-2/cover-fb.png'
  }
};

export const environment = { ...commonCbEnv, ...env };
